import { render, staticRenderFns } from "./TabClueAttachFiles.vue?vue&type=template&id=e739557c&"
import script from "./TabClueAttachFiles.vue?vue&type=script&lang=js&"
export * from "./TabClueAttachFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports